import { DEMO_PHONE } from '@/landing/content'
import { ArticlePage, articleMeta, type ArticleData } from '@/site/article'

const article: ArticleData = {
  path: '/blog/yak-ne-vtrachaty-dzvinky-pislya-18',
  lead:
    'Робочий день закінчився, а клієнти ні. Розбираємось, чому вечірні дзвінки особливо цінні, які є способи на них відповідати і як зробити, щоб зранку на вас чекали заявки, а не список пропущених.',
  sections: [
    {
      h2: 'Чому вечірній дзвінок цінніший, ніж здається',
      blocks: [
        'Удень людина дзвонить між справами. Увечері вона нарешті сіла розібратися з тим, що відкладала: записатися до стоматолога, домовитися про ремонт машини, замовити прибирання. Це вже не «дізнатися ціну на майбутнє», а намір вирішити питання зараз.',
        'Якщо ніхто не відповів, людина рідко чекає до ранку. Вона відкриває пошук і набирає наступний номер. Зранку ваш адміністратор передзвонить на пропущений, але клієнт уже записаний в інше місце або просто не візьме трубку з незнайомого номера.',
        'Скільки таких дзвінків у вас, можна порахувати за тиждень, без жодних нових сервісів. Як саме, ми описали в статті [«Як перевірити, скільки дзвінків ви пропускаєте»](/blog/skilky-dzvinkiv-vy-propuskayete).',
      ],
    },
    {
      h2: 'Спосіб 1. Автовідповідач з графіком роботи',
      blocks: [
        'Найпростіше рішення, яке вже є в будь-якого оператора чи АТС: повідомлення «ми працюємо з 9 до 18, зателефонуйте завтра». Воно чесне, але нічого не рятує: клієнт дізнається, що його не приймуть, і йде шукати тих, хто прийме.',
        'Трохи краще працює автовідповідач з проханням залишити голосове повідомлення. Але чимало людей кладуть трубку, щойно чують запис, а повідомлення, які все ж залишили, хтось має зранку прослухати й розібрати.',
      ],
    },
    {
      h2: 'Спосіб 2. Переадресація на мобільний',
      blocks: [
        'Власник чи черговий менеджер бере вечірні дзвінки на свій телефон. Це працює, поки дзвінків мало і людина готова відповідати за вечерею, у спортзалі чи о пів на одинадцяту. З часом таких дзвінків більшає, а запис клієнта «на коліні», без доступу до графіка, часто закінчується накладками.',
      ],
    },
    {
      h2: 'Спосіб 3. Колл-центр на аутсорсі',
      blocks: [
        'Зовнішні оператори приймають дзвінки вночі й у вихідні за скриптом. Плюс у тому, що відповідають живі люди. Мінуси: вартість росте разом з кількістю дзвінків, а оператор колл-центру не знає вашого бізнесу так, як ваш адміністратор, тож на нестандартні питання відповідає «передамо, вам передзвонять».',
      ],
    },
    {
      h2: 'Спосіб 4. AI-агент, який приймає дзвінки',
      blocks: [
        'Голосовий агент відповідає з першого гудка в будь-який час. Він знає ваші послуги, ціни і графік, бачить вільні вікна в календарі і записує клієнта одразу. Якщо питання потребує людини, приймає заявку, а система сама передзвонить клієнту в робочий час.',
        'Головна відмінність від автовідповідача: клієнт вирішує своє питання в цій же розмові. Від колл-центру: агент відповідає за вашою базою знань, а не за загальним скриптом, і ви платите за хвилини розмов, а не за операторів на зміні.',
        `Як це звучить, найпростіше почути самому: [демо-лінія Anytel](tel:${DEMO_PHONE}) відповідає цілодобово.`,
      ],
    },
    {
      h2: 'Як налаштувати вечірні дзвінки за один вечір',
      blocks: [
        {
          steps: [
            { title: 'Визначте, що агент має робити ввечері', text: 'Записувати в календар, приймати заявки на передзвін, відповідати на часті питання? Почніть з того, про що питають найчастіше.' },
            { title: 'Опишіть послуги і правила', text: 'Ціни, графік, адресу, як підготуватися до візиту, що робити в термінових випадках. Звичайним текстом, як пояснили б новому адміністратору.' },
            { title: 'Оберіть сценарій «Вдень оператор, вночі AI»', text: 'У робочі години дзвінки йдуть вашій команді, після закриття агенту. Робочі години задаються один раз.' },
            { title: 'Перевірте тестовим дзвінком', text: 'Подзвоніть агенту з браузера ввечері і спробуйте записатися як звичайний клієнт.' },
            { title: 'Увімкніть переадресацію', text: 'З номера, який знають клієнти. Номер міняти не потрібно.' },
          ],
        },
        'Зранку заявки з ночі вже будуть у кабінеті й [у Telegram](/funktsii/zayavky-v-telegram), а записи в календарі. Докладніше про налаштування в розділі [«Робота 24/7»](/funktsii/robota-24-7).',
      ],
    },
    {
      h2: 'Що зміниться за тиждень',
      blocks: [
        'Перший тиждень покаже те, чого раніше не було видно: скільки людей дзвонили після закриття, о котрій і з якими питаннями. Ці дані корисні навіть без агента: можливо, варто зсунути графік чи додати вечірню зміну. А записи розмов підкажуть, що додати в базу знань, щоб агент відповідав ще точніше.',
      ],
    },
  ],
  faq: [
    {
      q: 'Чи не відлякує клієнтів, що відповідає AI?',
      a: 'Клієнту головне вирішити питання. На початку розмови агент чесно попереджає, що він віртуальний асистент, а далі розмова йде звичайно: клієнт може перебити, перепитати, змінити час. Якщо клієнт хоче людину, агент приймає заявку на передзвін.',
    },
    {
      q: 'Скільки коштує агент лише на вечірні години?',
      a: 'Оплачуються кабінет і хвилини розмов. Якщо агент працює тільки ввечері, хвилин буде відповідно менше. Тарифи на сторінці [цін](/tsiny).',
    },
  ],
  related: ['/funktsii/robota-24-7', '/blog/skilky-dzvinkiv-vy-propuskayete', '/blog/ai-agent-chy-administrator', '/funktsii/zayavky-v-telegram'],
}

export const meta = articleMeta(article)

export default function Post() {
  return <ArticlePage article={article} />
}
